import Backbone from 'backbone';
import obstacle from './obstacle';
import { sortBy } from 'lodash';

const obstaclesCollection = Backbone.Collection.extend({
  initialize: function(){
    this.url = '/obstacles';
    this.model = obstacle;
  },

  alphabetical: function(){
    return sortBy(this.models, function(obstacle){
      return obstacle.name();
    });
  }
});

export default obstaclesCollection;
